import PropTypes from 'prop-types'
import { useState, useEffect, useCallback, useContext } from 'react'
import { LoginContext } from '../context/loginContext'
import { withValidador } from '../hoc/withValidador'
import { Checkbox } from '../reutilizables/checkbox/Checkbox'
import GenericSelect from '../reutilizables/genericSelect/GenericSelect'
import * as fetchLocalidadesAPI from '../servicios/fetchLocalidadesAPI'
import Input from '../ui/Input'

const Formulario = ({
  domicilio,
  provincias,
  provinciasAPI,
  showForm,
  onToggleFormHandler,
  onSave,
  onDelete,
  onChangeDomicilio,
  Validador
}) => {
  const [state, setState] = useState({
    domicilio: domicilio,
    provincias: provincias,
    actual: false,
    provinciasAPI: provinciasAPI,
    localidadesAPI: [],
    errores: {}
  })

  const [provincia, setProvincia] = useState('')
  const [localidad, setLocalidad] = useState('')

  const esquema = {
    tipoDomicilio: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': <>Ups, te olvidaste de completar el Nombre de domicilio!</>
        })
      }),
    calle: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': <>Ups, te olvidaste de completar la calle!</>
        })
      }),
    calleAltura: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': <>Ups, te olvidaste de completar la altura de la calle!</>
        })
      }),
    idProvincia: Validador.Kernel.number()
      .empty(0)
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe seleccionar una Provincia!</>
        })
      }),
    idLocalidad: Validador.Kernel.number()
      .empty(0)
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe ingresar una Localidad válida!</>
        })
      }),
    ciudad: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': <>Ups, te olvidaste de completar la ciudad!</>
        })
      }),
    cp: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': <>Ups, te olvidaste de completar el código postal!</>
        })
      })
  }

  useEffect(() => {
    if (domicilio.domicilioPrincipal !== state.domicilio.domicilioPrincipal) {
      setState((prevState) => ({
        ...prevState,
        domicilio: {
          ...prevState.domicilio,
          domicilioPrincipal: domicilio.domicilioPrincipal
        }
      }))
    }

    if (domicilio.domicilioFacturacion !== state.domicilio.domicilioFacturacion) {
      setState((prevState) => ({
        ...prevState,
        domicilio: {
          ...prevState.domicilio,
          domicilioFacturacion: domicilio.domicilioFacturacion
        }
      }))
    }
  }, [
    domicilio.domicilioPrincipal,
    domicilio.domicilioFacturacion,
    state.domicilio.domicilioPrincipal,
    state.domicilio.domicilioFacturacion
  ])

  const handleSubmit = useCallback((e) => {
    e.preventDefault()
  }, [])

  const formValido = useCallback(() => {
    const errores = Validador.validarForm(esquema, {
      tipoDomicilio: state.domicilio.tipoDomicilio,
      calle: state.domicilio.calle,
      calleAltura: state.domicilio.calleAltura,
      idProvincia: state.domicilio.idProvincia,
      idLocalidad: state.domicilio.idLocalidad,
      ciudad: state.domicilio.ciudad,
      cp: state.domicilio.cp
    })

    setState((prevState) => ({ ...prevState, errores: errores || {} }))
    if (errores) {
      Validador.foco()
      return false
    }
    return true
  }, [Validador, esquema, state.domicilio])

  const validarCampo = useCallback(
    (name) => {
      const errores = Validador.validarDato(
        esquema,
        {
          tipoDomicilio: state.domicilio.tipoDomicilio,
          calle: state.domicilio.calle,
          calleAltura: state.domicilio.calleAltura,
          idProvincia: state.domicilio.idProvincia,
          idLocalidad: state.domicilio.idLocalidad,
          ciudad: state.domicilio.ciudad,
          cp: state.domicilio.cp
        },
        name
      )

      setState((prevState) => ({ ...prevState, errores: errores || {} }))
    },
    [Validador, esquema, state.domicilio]
  )

  const submit = useCallback(
    async (e, accion) => {
      if (accion === 'grabar') {
        if (!formValido()) {
          return
        }
        onSave(state.domicilio.idUsuarioDomicilio, state.domicilio)
      } else {
        /* Si el domicilio a eliminar no esta marcado como domicilio de Facturacion y/o Principal, entonces lo elimina. De lo contrario, No deja eliminar. */
        if (!state.domicilio.domicilioPrincipal && !state.domicilio.domicilioFacturacion) {
          onDelete(state.domicilio.idUsuarioDomicilio)
        } else {
          let oMsj = ''
          if (state.domicilio.domicilioPrincipal) {
            oMsj = {
              domicilioPrincipal: 'No se puede eliminar Domicilio marcado como Principal'
            }
          } else {
            oMsj = {
              domicilioFacturacion: 'No se puede eliminar Domicilio marcado como Facturación'
            }
          }

          setState((prevState) => ({ ...prevState, errores: oMsj }))
          Validador.foco()
        }
      }
    },
    [formValido, onSave, onDelete, state.domicilio, Validador]
  )

  const handleChange = useCallback(
    (e) => {
      const { name, value, type, checked } = e.target
      setState((prevState) => ({
        ...prevState,
        domicilio: {
          ...prevState.domicilio,
          [name]: type === 'checkbox' ? checked : value
        }
      }))
      validarCampo(name)
    },
    [validarCampo]
  )

  const handleChangeLocalidad = useCallback(
    (name, localidad) => {
      setState((prevState) => ({
        ...prevState,
        domicilio: { ...prevState.domicilio, localidad: localidad }
      }))
      validarCampo(name)
    },
    [validarCampo]
  )

  const buscarLocalidadesEnEBM = async () => {
    const { data: localidades } = await fetchLocalidadesAPI.buscarLocalidadesEnEBM(provincia)
    setState((prevState) => ({ ...prevState, localidades }))
  }

  const handleProvincia = async (provincia) => {
    setState((prevState) => ({ ...prevState, provincia }))

    const request = new Request(
      `https://apis.datos.gob.ar/georef/api/localidades?provincia=${provincia}&max=1000`
    )

    try {
      const resp = await fetch(request)
      const data = await resp.json()

      setState((prevState) => ({ ...prevState, localidadesAPI: data.localidades || [] }))
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('error', err)
      buscarLocalidadesEnEBM()
    }
  }

  const handleChangeProvincia = useCallback(
    ({ name, target: provincia }) => {
      setState((prevState) => ({
        ...prevState,
        domicilio: { ...prevState.domicilio, provincia: provincia }
      }))
      validarCampo(name)
      handleProvincia(provincia)
    },
    [validarCampo]
  )

  const { loginDataContext } = useContext(LoginContext)
  const tipoUsuario = loginDataContext.tipoUsuario

  return (
    <>
      <div
        onClick={
          onToggleFormHandler && (() => onToggleFormHandler(state.domicilio.idUsuarioDomicilio))
        }
        className={`btn-domicilios ${
          state.domicilio.domicilioPrincipal
            ? 'border-green-2px fa fa-check-circle aria-hidden="true"'
            : ''
        }`}
      >
        <span className="buttonText">
          <span className="buttonTextDomicilio">
            <div key={state.domicilio.idUsuarioDomicilio}>{state.domicilio.tipoDomicilio}</div>
          </span>
          <span className="buttonTextDomicilio">
            <div>
              {state.domicilio.calle} {state.domicilio.numero}
            </div>
          </span>
        </span>
      </div>
      <div>
        {showForm && (
          <form
            id="modificarDomicilio"
            className={
              tipoUsuario === 'A' || !state.domicilio.vieneDeEBM
                ? 'disabled'
                : 'form-datos-perfil mt-2 mb-4'
            }
            onSubmit={handleSubmit}
          >
            <label htmlFor="">Nombre Domicilio</label>
            <Input
              type="text"
              name="tipoDomicilio"
              value={state.domicilio.tipoDomicilio}
              onChange={handleChange}
              className="input-text-bordered"
              placeholder=""
              errores={state.errores}
            />

            <div>
              <Checkbox
                name="domicilioPrincipal"
                className={tipoUsuario === 'P' ? 'disabled' : null}
                type="checkbox"
                checked={state.domicilio.domicilioPrincipal}
                onChange={(e) => onChangeDomicilio(e, state.domicilio.idUsuarioDomicilio)}
                errores={state.errores}
              />
              <label htmlFor="">Marcar como Domicilio Principal. </label>
            </div>

            <div>
              <Checkbox
                name="domicilioFacturacion"
                type="checkbox"
                className={tipoUsuario === 'P' ? 'disabled' : null}
                checked={state.domicilio.domicilioFacturacion}
                onChange={(e) => onChangeDomicilio(e, state.domicilio.idUsuarioDomicilio)}
                errores={state.errores}
              />
              <label htmlFor="">Marcar como Domicilio de Facturación.</label>
            </div>

            <hr className="hr-perfil w-80"></hr>

            <label htmlFor="">Calle: </label>
            <Input
              type="text"
              name="calle"
              value={state.domicilio.calle}
              onChange={handleChange}
              className="input-text-bordered"
              placeholder=""
              errores={state.errores}
            />

            <label htmlFor="">Altura</label>
            <Input
              type="text"
              name="calleAltura"
              value={state.domicilio.calleAltura}
              onChange={handleChange}
              className="input-text-bordered"
              placeholder=""
              errores={state.errores}
            />

            <label htmlFor="">Piso</label>
            <Input
              type="text"
              name="piso"
              value={state.domicilio.piso}
              onChange={handleChange}
              className="input-text-bordered"
              placeholder=""
            />

            <label htmlFor="">Departamento o Casa</label>
            <Input
              type="text"
              name="departamento"
              value={state.domicilio.departamento}
              onChange={handleChange}
              className="input-text-bordered"
              placeholder=""
            />

            {!state.domicilio.vieneDeEBM ? (
              <>
                <p>Provincia</p>
                <div className="input-text-bordered">{state.domicilio.provincia}</div>
                <p>Ciudad</p>
                <div className="input-text-bordered">{state.domicilio.ciudad}</div>
              </>
            ) : (
              <>
                <label htmlFor="">Provincia</label>
                <GenericSelect
                  options={provinciasAPI.map((prov) => ({
                    value: prov.nombre,
                    label: prov.nombre
                  }))}
                  value={provincia}
                  onChange={(v) => {
                    setProvincia(v)
                    handleChangeProvincia({ target: v, name: 'provincia' })
                  }}
                  placeholder="Seleccionar una provincia"
                  id="provincia"
                />
                <label htmlFor="">Ciudad</label>
                <GenericSelect
                  options={state.localidadesAPI.map((localidad) => ({
                    value: localidad.id,
                    label: localidad.nombre,
                    key: localidad.id
                  }))}
                  value={localidad}
                  onChange={(v) => {
                    setLocalidad(v)
                    handleChangeLocalidad({ target: v, name: 'localidad' })
                  }}
                  placeholder="Seleccionar una localidad"
                  id="localidad"
                />
              </>
            )}
            <label htmlFor="">Código Postal</label>
            <Input
              type="text"
              name="cp"
              value={state.domicilio.cp}
              onChange={handleChange}
              className="input-text-bordered"
              placeholder=""
              errores={state.errores}
            />

            <label htmlFor="">Anotaciones para entrega</label>
            <textarea
              type="text"
              name="anotaciones"
              value={state.domicilio.anotaciones}
              onChange={handleChange}
              className="input-text-bordered anotaciones"
              placeholder=""
            />

            {state.domicilio.vieneDeEBM && (
              <div className="text-center">
                <button
                  id="botonGuardar"
                  name="botonGuardar"
                  className="btn btn-borde-verde w-40"
                  onClick={(e) => {
                    submit(e, 'grabar')
                  }}
                >
                  Guardar
                </button>

                <button
                  id="botonEliminar"
                  name="botonEliminar"
                  className="btn btn-borde-rojo w-40"
                  onClick={(e) => {
                    submit(e, 'eliminar')
                  }}
                >
                  Eliminar
                </button>
              </div>
            )}
          </form>
        )}
      </div>
    </>
  )
}

Formulario.propTypes = {
  domicilio: PropTypes.object.isRequired,
  provincias: PropTypes.array,
  provinciasAPI: PropTypes.array.isRequired,
  showForm: PropTypes.bool.isRequired,
  onToggleFormHandler: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onChangeDomicilio: PropTypes.func.isRequired,
  Validador: PropTypes.shape({
    Kernel: PropTypes.object,
    mensaje: PropTypes.func,
    validarForm: PropTypes.func,
    validarDato: PropTypes.func,
    foco: PropTypes.func
  }).isRequired
}

export default withValidador(Formulario)
